import { Input } from "antd";
import type { InputProps } from "antd";
import type { TextAreaProps } from "antd/es/input";
import type { SearchProps } from "antd/es/input/Search";
import type { PasswordProps } from "antd/es/input/Password";

export type CommonInputProps = InputProps;
export type CommonInputTextAreaProps = TextAreaProps;
export type CommonInputSearchProps = SearchProps;
export type CommonInputPasswordProps = PasswordProps;

export const CommonInput = (props: CommonInputProps) => {
  return <Input {...props} />;
};

export const CommonInputTextArea = (props: CommonInputTextAreaProps) => {
  return <Input.TextArea {...props} />;
};

export const CommonInputSearch = (props: CommonInputSearchProps) => {
  return <Input.Search {...props} />;
};

export const CommonInputPassword = (props: CommonInputPasswordProps) => {
  return <Input.Password {...props} />;
};
